import React__default from 'react';
import dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as iTimezone from 'dayjs/plugin/timezone';
import useConfig from '../../../Hooks/useConfig.js';
import useAppService from '../../../Hooks/useAppService.js';

dayjs.extend(utc.default);
dayjs.extend(iTimezone.default);
const DateDisplay = (props) => {
    const { date, format, utc, stripTz, tz, stripTime, customDateFormat } = props;
    const config = useConfig();
    const appService = useAppService();
    // stripTz expect into to be "2002-02-14T14:23:56+06:00" --> 2002-02-14T14:23:56
    let dateString = stripTz ? date.substr(0, 19) : date;
    dateString = stripTime ? date.substr(0, 10) : dateString;
    const timezone = tz;
    function getDefaultFormat() {
        const defaultFormat = config.displayFormatDate[appService.lang.replace('-', '_')];
        return defaultFormat ? defaultFormat : config.displayFormatDate[config.defaultLanguage];
    }
    function getDate() {
        const dateVal = utc ? dayjs.utc(dateString) : dayjs(dateString);
        if (timezone) {
            return dateVal.tz(timezone);
        }
        return dateVal;
    }
    const dateFormat = format || getDefaultFormat();
    return !customDateFormat ? (React__default.createElement(React__default.Fragment, null, getDate().format(dateFormat))) : (React__default.createElement(React__default.Fragment, null, dayjs(date).format('DD.MM.YY')));
};

export { DateDisplay as default };
//# sourceMappingURL=DateDisplay.js.map
